/**
 * Convierte un texto a formato de nombre propio (Title Case)
 * @param text - El texto a convertir
 * @returns El texto en formato de nombre propio
 */
export function toTitleCase(text: string): string {
  if (!text) return '';
  
  // Palabras que no deben ser capitalizadas en el medio de una frase
  const minorWords = ['de', 'del', 'la', 'las', 'el', 'los', 'y', 'e', 'o', 'u', 'con', 'por', 'para', 'en', 'a', 'al'];
  
  // Sufijos de empresas que deben mantenerse en mayúsculas (con y sin puntos)
  const companySuffixes = ['s.a.', 's.a', 's.l.', 's.l', 'ltd.', 'ltd', 'inc.', 'inc', 'corp.', 'corp', 'llc', 's.r.l.', 's.r.l', 's.c.', 's.c', 'ltda.', 'ltda', 'cia.', 'cia', 'co.', 'co', 's.a.s.', 's.a.s'];
  
  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      // Verificar si es un sufijo de empresa (mantener en mayúsculas)
      if (companySuffixes.includes(word)) {
        return word.toUpperCase();
      }
      
      // La primera palabra siempre se capitaliza
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      
      // Si es una palabra menor, se mantiene en minúscula
      if (minorWords.includes(word)) {
        return word;
      }
      
      // Capitalizar la primera letra
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

/**
 * Formatea un texto de dirección con formato apropiado
 * @param address - La dirección a formatear
 * @returns La dirección formateada
 */
export function formatAddress(address: string): string {
  if (!address) return '';
  
  // Capitalizar cada palabra excepto preposiciones comunes
  return address
    .split(',')
    .map(part => toTitleCase(part.trim()))
    .join(', ');
}